import { IconButton } from "@mui/material"
import IconSeeker from "./IconSeeker"

export default function ButtonIconSeeker({ icon, iconWeight, iconProps = {}, tooltip = null, ...props }) {
    return (
        <IconButton {...props}>
            <IconSeeker icon={icon} iconWeight={iconWeight} tooltip={tooltip} {...iconProps} />
        </IconButton>
    )
}
